// extracted by mini-css-extract-plugin
module.exports = {"chart":"GlobalChart_chart__1i3-I"};